import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Target } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { MissionPage } from "./pages/MissionPage";

export const missionModule: FeatureModule = {
  key: "mission",
  nav: {
    label: "Mission",
    icon: Target,
    to: "/mission",
    // Visible to any authenticated user — it's the company mission, not gated.
    requires: "",
    order: 5,
    group: "Overview",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/mission",
      component: guarded("", MissionPage),
    }),
    // Default landing page: anyone who signs in lands here, no permission needed.
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/",
      component: guarded("", MissionPage),
    }),
  ] as unknown as AnyRoute[],
};
